import { BookCollectionList } from './BookCollectionList'
import { withBookCollectionList } from './withBookCollectionList'

const ConnectedBookCollectionList = withBookCollectionList(BookCollectionList)
export { ConnectedBookCollectionList as BookCollectionList }
